<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-sticky>
        <van-tabs
          v-model:active="tabActive"
          title-active-color="#222"
          color="#222"
          line-width="28px"
          line-height="4px"
          @click-tab="onClickTab"
          :disabled="loading"
        >
          <van-tab v-for="item in tabData" :title="item.label" :key="item.value" :name="item.value" />
        </van-tabs>
      </van-sticky>
      <div class="content-box">
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div class="coupon-list con-wrp">
            <div v-for="item in list" :key="item.rid" class="coupon-item">
              <div class="img-box">
                <van-image :width="transPxToRem(60)" :height="transPxToRem(52)" :src="exchangeCouponIcon" />
              </div>
              <div class="content">
                <div class="coupon-name">{{ item.coupon_name }}</div>
                <div class="coupon-time">
                  <div>有效期：{{ item.start_time }}~</div>
                  <div>{{ item.end_time }}</div>
                </div>
              </div>
              <div class="not-effect-tag" v-if="item.status === 3">待生效</div>
            </div>
          </div>
        </van-list>
        <van-empty v-if="list.length == 0 && !loading" image-size="240" image="https://i.xurl.cn/x_dsx_wxapp/empty/coupon.png" description="暂无优惠券" />
      </div>
    </van-pull-refresh>
    <div class="footer-bar" @click="goExchangeRecord()">
      <span>兑换券记录</span>
      <van-icon color="#222" name="arrow" :size="transPxToRem(12)" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import { Image as VanImage } from 'vant'
import exchangeCouponIcon from '@/assets/img/exchange-coupon-icon.png'
import { transPxToRem } from '@/utils'
import usePage from '@/hooks/usePage'
import { getMemberCouponList } from '@/api/coupon'

const { navigateTo } = usePage()
const tabData = ref([
  {
    label: '未使用',
    value: 1
  },
  {
    label: '待生效',
    value: 3
  }
])
const tabActive = ref(1)
const pageParams = reactive({
  page: 1,
  pageSize: 20
})
// const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))
const onClickTab = () => {
  reset()
  getList()
}

const reset = () => {
  list.value = []
  pageParams.page = 1
  finished.value = false
}
const getList = async () => {
  loading.value = true
  try {
    const resData = await getMemberCouponList({ ...pageParams, coupon_status: tabActive.value, coupon_type: 3 })
    list.value.push(
      ...resData.list.map(d => ({
        ...d,
        isShowDes: true,
        desList: d.remark ? [`备注：${d.remark}`] : []
      }))
    )
    pageParams.page++
    finished.value = list.value.length >= +resData.total
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const goExchangeRecord = () => {
  navigateTo('/exchangeCouponRecord')
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}
onMounted(() => {
  try {
    getList()
  } catch (e) {
    console.log(e)
  }
})
</script>
<style scoped lang="less">
.page-container {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: calc(5px + env(safe-area-inset-bottom));
  overflow: auto;
  .content-box {
    padding-bottom: 60px;
    .coupon-list {
      .coupon-item {
        display: flex;
        border-radius: 8px;
        overflow: hidden;
        background-color: #fff;
        margin: 12px;
        align-items: center;
        position: relative;
        .img-box {
          padding: 22px 16px;
          border-right: 1px dashed #eaeaea;
        }
        .content {
          padding: 0 16px;
          .coupon-name {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            height: 22px;
            margin-bottom: 10px;
          }
          .coupon-time {
            color: #999999;
            font-size: 12px;
          }
        }
        .not-effect-tag {
          position: absolute;
          right: 0;
          color: #fff;
          padding: 0 16px;
          background-color: #ff6262;
          transform: rotate(45deg);
          font-size: 9px;
          right: -17px;
          top: 7px;
        }
      }
    }
  }
  .footer-bar {
    position: fixed;
    background-color: #fff;
    padding: 16px 0;
    bottom: 0;
    width: 100vw;
    text-align: center;
  }
}
</style>
